var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 822,
    height: 526,
    viewBox: "0 0 822 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_438)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 526,
    rx: 24,
    fill: "#021D1D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 18,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 60,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 102,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 144,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 186,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 228,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 270,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 312,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 354,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 396,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 438,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 480,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 522,
    width: 2,
    height: 2,
    fill: "#16F3A2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 223.222,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 210.395,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 313.924,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 302.93,
    width: 504.815,
    height: 0.91618,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.051,
    y: 171,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.348,
    y: 171,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.482,
    y: 171,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.177,
    y: 171,
    width: 0.91618,
    height: 183.236,
    fill: "#16F3A2",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-270-outside-1_71_438",
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 212,
    width: 390,
    height: 103,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 215,
    y: 212,
    width: 390,
    height: 103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 304.22L229.178 308.639C237.386 287.068 246.387 267.314 257.508 251.721C268.097 236.907 277.893 229.37 283.982 227.032C290.071 224.693 291.129 227.811 290.071 233.53C289.013 239.766 285.307 248.344 282.127 256.142C277.89 266.017 273.126 277.192 273.126 285.77C273.126 293.827 278.684 300.064 285.834 300.064C293.778 300.064 300.661 290.968 306.22 283.69C317.073 268.876 325.811 261.861 320.516 281.09C318.134 290.965 316.015 299.284 322.104 307.338C327.663 314.875 339.047 316.955 349.373 308.639L342.49 298.763C334.546 304.22 330.312 301.882 331.106 293.824C331.637 288.627 335.343 279.79 335.343 271.995C335.343 262.899 328.991 256.66 321.047 256.922C311.781 257.18 303.837 267.576 297.485 275.374C294.572 279.013 287.425 289.668 286.101 287.329C283.982 283.691 291.132 268.097 294.308 261.081C298.809 249.906 303.574 238.73 303.574 229.894C303.574 219.498 296.16 213 287.159 213C265.979 212.997 235.797 252.762 217 304.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 225.705C415.132 225.705 421.828 227.478 426.567 231.026C431.382 234.574 433.789 239.525 433.789 245.881C433.789 250.538 432.511 254.381 429.953 257.411C427.47 260.367 423.859 262.363 419.119 263.398C430.931 265.393 436.836 271.491 436.836 281.69C436.836 288.415 434.278 293.7 429.163 297.543C424.122 301.386 416.9 303.308 407.496 303.308H377.478V225.705H406.48ZM390.456 258.631H406.819C411.258 258.631 414.681 257.633 417.088 255.637C419.571 253.642 420.812 250.907 420.812 247.434C420.812 243.96 419.571 241.262 417.088 239.341C414.681 237.345 411.258 236.347 406.819 236.347H390.456V258.631ZM390.456 292.554H407.609C412.725 292.554 416.637 291.556 419.345 289.561C422.129 287.492 423.52 284.646 423.52 281.025C423.52 277.255 422.129 274.336 419.345 272.267C416.561 270.197 412.649 269.162 407.609 269.162H390.456V292.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 275.038C445.504 269.199 446.671 264.1 449.003 259.739C451.41 255.305 454.72 251.905 458.933 249.54C463.222 247.101 468.112 245.881 473.604 245.881C479.171 245.881 484.061 246.99 488.274 249.207C492.562 251.425 495.91 254.566 498.317 258.631C500.8 262.695 502.079 267.463 502.154 272.932C502.154 274.41 502.041 275.925 501.815 277.477H458.256V278.142C458.557 283.094 460.137 287.011 462.996 289.894C465.855 292.776 469.654 294.217 474.393 294.217C478.155 294.217 481.315 293.367 483.873 291.667C486.431 289.894 488.123 287.418 488.951 284.24H501.138C500.085 290.004 497.226 294.735 492.562 298.43C487.973 302.125 482.218 303.973 475.296 303.973C469.278 303.973 464.012 302.79 459.498 300.425C455.059 297.986 451.598 294.587 449.116 290.226C446.708 285.866 445.504 280.803 445.504 275.038ZM489.741 268.719C489.214 264.58 487.521 261.365 484.663 259.074C481.879 256.709 478.343 255.526 474.055 255.526C470.068 255.526 466.607 256.746 463.673 259.185C460.814 261.55 459.159 264.728 458.708 268.719H489.741Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 257.078H505.247V246.547H515.29V230.693H527.591V246.547H541.471V257.078H527.591V286.679C527.591 288.896 528.042 290.485 528.945 291.446C529.848 292.333 531.39 292.776 533.572 292.776H542.825V303.308H531.089C525.597 303.308 521.572 302.051 519.014 299.539C516.532 297.026 515.29 293.146 515.29 287.898V257.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 292.887V303.308H597.568C593.806 303.308 591.098 302.532 589.443 300.98C587.788 299.428 586.96 297.173 586.96 294.217C582.597 300.721 576.24 303.973 567.889 303.973C561.419 303.973 556.228 302.495 552.316 299.539C548.404 296.582 546.448 292.517 546.448 287.344C546.448 281.505 548.554 277.034 552.767 273.929C556.98 270.751 563.112 269.162 571.161 269.162H585.719V265.726C585.719 262.548 584.59 260.072 582.333 258.298C580.076 256.45 576.954 255.526 572.967 255.526C569.431 255.526 566.497 256.302 564.165 257.855C561.908 259.333 560.554 261.328 560.102 263.841H548.14C548.742 258.15 551.3 253.753 555.814 250.649C560.328 247.47 566.234 245.881 573.531 245.881C581.28 245.881 587.261 247.655 591.474 251.203C595.687 254.75 597.793 259.85 597.793 266.502V288.896C597.793 291.556 599.072 292.887 601.63 292.887H604ZM585.719 278.031H570.597C566.835 278.031 563.939 278.77 561.908 280.249C559.877 281.653 558.861 283.759 558.861 286.568C558.861 289.007 559.801 290.965 561.682 292.443C563.638 293.922 566.271 294.661 569.581 294.661C574.622 294.661 578.534 293.33 581.318 290.67C584.176 288.009 585.643 284.461 585.719 280.027V278.031Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217 304.22L229.178 308.639C237.386 287.068 246.387 267.314 257.508 251.721C268.097 236.907 277.893 229.37 283.982 227.032C290.071 224.693 291.129 227.811 290.071 233.53C289.013 239.766 285.307 248.344 282.127 256.142C277.89 266.017 273.126 277.192 273.126 285.77C273.126 293.827 278.684 300.064 285.834 300.064C293.778 300.064 300.661 290.968 306.22 283.69C317.073 268.876 325.811 261.861 320.516 281.09C318.134 290.965 316.015 299.284 322.104 307.338C327.663 314.875 339.047 316.955 349.373 308.639L342.49 298.763C334.546 304.22 330.312 301.882 331.106 293.824C331.637 288.627 335.343 279.79 335.343 271.995C335.343 262.899 328.991 256.66 321.047 256.922C311.781 257.18 303.837 267.576 297.485 275.374C294.572 279.013 287.425 289.668 286.101 287.329C283.982 283.691 291.132 268.097 294.308 261.081C298.809 249.906 303.574 238.73 303.574 229.894C303.574 219.498 296.16 213 287.159 213C265.979 212.997 235.797 252.762 217 304.22Z",
    fill: "url(#paint0_linear_71_438)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 225.705C415.132 225.705 421.828 227.478 426.567 231.026C431.382 234.574 433.789 239.525 433.789 245.881C433.789 250.538 432.511 254.381 429.953 257.411C427.47 260.367 423.859 262.363 419.119 263.398C430.931 265.393 436.836 271.491 436.836 281.69C436.836 288.415 434.278 293.7 429.163 297.543C424.122 301.386 416.9 303.308 407.496 303.308H377.478V225.705H406.48ZM390.456 258.631H406.819C411.258 258.631 414.681 257.633 417.088 255.637C419.571 253.642 420.812 250.907 420.812 247.434C420.812 243.96 419.571 241.262 417.088 239.341C414.681 237.345 411.258 236.347 406.819 236.347H390.456V258.631ZM390.456 292.554H407.609C412.725 292.554 416.637 291.556 419.345 289.561C422.129 287.492 423.52 284.646 423.52 281.025C423.52 277.255 422.129 274.336 419.345 272.267C416.561 270.197 412.649 269.162 407.609 269.162H390.456V292.554Z",
    fill: "url(#paint1_linear_71_438)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 275.038C445.504 269.199 446.671 264.1 449.003 259.739C451.41 255.305 454.72 251.905 458.933 249.54C463.222 247.101 468.112 245.881 473.604 245.881C479.171 245.881 484.061 246.99 488.274 249.207C492.562 251.425 495.91 254.566 498.317 258.631C500.8 262.695 502.079 267.463 502.154 272.932C502.154 274.41 502.041 275.925 501.815 277.477H458.256V278.142C458.557 283.094 460.137 287.011 462.996 289.894C465.855 292.776 469.654 294.217 474.393 294.217C478.155 294.217 481.315 293.367 483.873 291.667C486.431 289.894 488.123 287.418 488.951 284.24H501.138C500.085 290.004 497.226 294.735 492.562 298.43C487.973 302.125 482.218 303.973 475.296 303.973C469.278 303.973 464.012 302.79 459.498 300.425C455.059 297.986 451.598 294.587 449.116 290.226C446.708 285.866 445.504 280.803 445.504 275.038ZM489.741 268.719C489.214 264.58 487.521 261.365 484.663 259.074C481.879 256.709 478.343 255.526 474.055 255.526C470.068 255.526 466.607 256.746 463.673 259.185C460.814 261.55 459.159 264.728 458.708 268.719H489.741Z",
    fill: "url(#paint2_linear_71_438)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 257.078H505.247V246.547H515.29V230.693H527.591V246.547H541.471V257.078H527.591V286.679C527.591 288.896 528.042 290.485 528.945 291.446C529.848 292.333 531.39 292.776 533.572 292.776H542.825V303.308H531.089C525.597 303.308 521.572 302.051 519.014 299.539C516.532 297.026 515.29 293.146 515.29 287.898V257.078Z",
    fill: "url(#paint3_linear_71_438)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 292.887V303.308H597.568C593.806 303.308 591.098 302.532 589.443 300.98C587.788 299.428 586.96 297.173 586.96 294.217C582.597 300.721 576.24 303.973 567.889 303.973C561.419 303.973 556.228 302.495 552.316 299.539C548.404 296.582 546.448 292.517 546.448 287.344C546.448 281.505 548.554 277.034 552.767 273.929C556.98 270.751 563.112 269.162 571.161 269.162H585.719V265.726C585.719 262.548 584.59 260.072 582.333 258.298C580.076 256.45 576.954 255.526 572.967 255.526C569.431 255.526 566.497 256.302 564.165 257.855C561.908 259.333 560.554 261.328 560.102 263.841H548.14C548.742 258.15 551.3 253.753 555.814 250.649C560.328 247.47 566.234 245.881 573.531 245.881C581.28 245.881 587.261 247.655 591.474 251.203C595.687 254.75 597.793 259.85 597.793 266.502V288.896C597.793 291.556 599.072 292.887 601.63 292.887H604ZM585.719 278.031H570.597C566.835 278.031 563.939 278.77 561.908 280.249C559.877 281.653 558.861 283.759 558.861 286.568C558.861 289.007 559.801 290.965 561.682 292.443C563.638 293.922 566.271 294.661 569.581 294.661C574.622 294.661 578.534 293.33 581.318 290.67C584.176 288.009 585.643 284.461 585.719 280.027V278.031Z",
    fill: "url(#paint4_linear_71_438)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 304.22L229.178 308.639C237.386 287.068 246.387 267.314 257.508 251.721C268.097 236.907 277.893 229.37 283.982 227.032C290.071 224.693 291.129 227.811 290.071 233.53C289.013 239.766 285.307 248.344 282.127 256.142C277.89 266.017 273.126 277.192 273.126 285.77C273.126 293.827 278.684 300.064 285.834 300.064C293.778 300.064 300.661 290.968 306.22 283.69C317.073 268.876 325.811 261.861 320.516 281.09C318.134 290.965 316.015 299.284 322.104 307.338C327.663 314.875 339.047 316.955 349.373 308.639L342.49 298.763C334.546 304.22 330.312 301.882 331.106 293.824C331.637 288.627 335.343 279.79 335.343 271.995C335.343 262.899 328.991 256.66 321.047 256.922C311.781 257.18 303.837 267.576 297.485 275.374C294.572 279.013 287.425 289.668 286.101 287.329C283.982 283.691 291.132 268.097 294.308 261.081C298.809 249.906 303.574 238.73 303.574 229.894C303.574 219.498 296.16 213 287.159 213C265.979 212.997 235.797 252.762 217 304.22Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-270-outside-1_71_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.48 225.705C415.132 225.705 421.828 227.478 426.567 231.026C431.382 234.574 433.789 239.525 433.789 245.881C433.789 250.538 432.511 254.381 429.953 257.411C427.47 260.367 423.859 262.363 419.119 263.398C430.931 265.393 436.836 271.491 436.836 281.69C436.836 288.415 434.278 293.7 429.163 297.543C424.122 301.386 416.9 303.308 407.496 303.308H377.478V225.705H406.48ZM390.456 258.631H406.819C411.258 258.631 414.681 257.633 417.088 255.637C419.571 253.642 420.812 250.907 420.812 247.434C420.812 243.96 419.571 241.262 417.088 239.341C414.681 237.345 411.258 236.347 406.819 236.347H390.456V258.631ZM390.456 292.554H407.609C412.725 292.554 416.637 291.556 419.345 289.561C422.129 287.492 423.52 284.646 423.52 281.025C423.52 277.255 422.129 274.336 419.345 272.267C416.561 270.197 412.649 269.162 407.609 269.162H390.456V292.554Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-270-outside-1_71_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.504 275.038C445.504 269.199 446.671 264.1 449.003 259.739C451.41 255.305 454.72 251.905 458.933 249.54C463.222 247.101 468.112 245.881 473.604 245.881C479.171 245.881 484.061 246.99 488.274 249.207C492.562 251.425 495.91 254.566 498.317 258.631C500.8 262.695 502.079 267.463 502.154 272.932C502.154 274.41 502.041 275.925 501.815 277.477H458.256V278.142C458.557 283.094 460.137 287.011 462.996 289.894C465.855 292.776 469.654 294.217 474.393 294.217C478.155 294.217 481.315 293.367 483.873 291.667C486.431 289.894 488.123 287.418 488.951 284.24H501.138C500.085 290.004 497.226 294.735 492.562 298.43C487.973 302.125 482.218 303.973 475.296 303.973C469.278 303.973 464.012 302.79 459.498 300.425C455.059 297.986 451.598 294.587 449.116 290.226C446.708 285.866 445.504 280.803 445.504 275.038ZM489.741 268.719C489.214 264.58 487.521 261.365 484.663 259.074C481.879 256.709 478.343 255.526 474.055 255.526C470.068 255.526 466.607 256.746 463.673 259.185C460.814 261.55 459.159 264.728 458.708 268.719H489.741Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-270-outside-1_71_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29 257.078H505.247V246.547H515.29V230.693H527.591V246.547H541.471V257.078H527.591V286.679C527.591 288.896 528.042 290.485 528.945 291.446C529.848 292.333 531.39 292.776 533.572 292.776H542.825V303.308H531.089C525.597 303.308 521.572 302.051 519.014 299.539C516.532 297.026 515.29 293.146 515.29 287.898V257.078Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-270-outside-1_71_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 292.887V303.308H597.568C593.806 303.308 591.098 302.532 589.443 300.98C587.788 299.428 586.96 297.173 586.96 294.217C582.597 300.721 576.24 303.973 567.889 303.973C561.419 303.973 556.228 302.495 552.316 299.539C548.404 296.582 546.448 292.517 546.448 287.344C546.448 281.505 548.554 277.034 552.767 273.929C556.98 270.751 563.112 269.162 571.161 269.162H585.719V265.726C585.719 262.548 584.59 260.072 582.333 258.298C580.076 256.45 576.954 255.526 572.967 255.526C569.431 255.526 566.497 256.302 564.165 257.855C561.908 259.333 560.554 261.328 560.102 263.841H548.14C548.742 258.15 551.3 253.753 555.814 250.649C560.328 247.47 566.234 245.881 573.531 245.881C581.28 245.881 587.261 247.655 591.474 251.203C595.687 254.75 597.793 259.85 597.793 266.502V288.896C597.793 291.556 599.072 292.887 601.63 292.887H604ZM585.719 278.031H570.597C566.835 278.031 563.939 278.77 561.908 280.249C559.877 281.653 558.861 283.759 558.861 286.568C558.861 289.007 559.801 290.965 561.682 292.443C563.638 293.922 566.271 294.661 569.581 294.661C574.622 294.661 578.534 293.33 581.318 290.67C584.176 288.009 585.643 284.461 585.719 280.027V278.031Z",
    stroke: "#16F3A2",
    strokeWidth: 2,
    mask: "url(#path-270-outside-1_71_438)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_438",
    x1: 410.5,
    y1: 213,
    x2: 410.5,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_438",
    x1: 410.5,
    y1: 213,
    x2: 410.5,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_438",
    x1: 410.5,
    y1: 213,
    x2: 410.5,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_438",
    x1: 410.5,
    y1: 213,
    x2: 410.5,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_438",
    x1: 410.5,
    y1: 213,
    x2: 410.5,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16F3A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F3A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 526,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.f25007942d3db26c90d4a01132894a0e.svg";
export { ForwardRef as ReactComponent };